export default __webpack_public_path__ + "static/media/alert.20ac8384.svg";